/**
 * The SKU types the API accepts, mirroring SkuTypeEnum. Declared once here
 * because a new type otherwise has to be added to the same union in half a
 * dozen places.
 */
export type SkuType = 'item' | 'case' | 'package' | 'equipment';

/** The categories an equipment SKU can belong to (ClickUp 86bbmbgfc). */
export const EQUIPMENT_CATEGORIES = [
  'Return Bin',
  'BOH Receptacle',
  'Marketing Supplies',
  'Hub Equipment',
  'Tech Equipment',
] as const;

export type SKU = {
  _id: string;
  createdAt: Date;
  prefix: string;
  updatedAt: Date;
  name: string;
  code: string;
  size: number;
  type: string;
  itemType: string;
  washHub: string;
  washHubCode: string;
  designVersion: string;
  primaryColor: string;
  poorLines: string;
  weight: string;
  material: string;
  /** A manufacturers_mst _id; the name arrives joined in as below. */
  manufacturer?: string;
  manufacturerDetails?: { _id: string; name: string };
  /** Equipment SKUs only. */
  category?: string;
  itemsInCase?: number;
  items?: Array<{
    sku: string;
    quantity: number;
    _id: string;
    details?: any;
  }>;
  pricePerDelivery?: number;
  pricePerReplacement?: number;
  caseSku?: string;
  artNumbers?: string[];
  manufacturerItemsInBox?: number;
  manufacturerBoxCostPerMoq?: Record<string, number>;
  manufacturerDescription?: string;
  manufacturerSkuId?: string;
  /** Price per unit, keyed by minimum order quantity in units. */
  manufacturerUnitCostPerMoq?: Record<string, number>;
  manufacturerPalletCount?: number;
  qrEnabled?: boolean;
  isSuspended?: boolean;
};

export type skuDetails = {
  _id: string;
  name: string;
  description: string;
  type: string;
  isDeleted: boolean;
  caseSku: string;
  items: Array<{
    sku: string;
    quantity: number;
    _id: string;
  }>;
  createdAt: Date;
  updatedAt: Date;
  isSuspended: boolean;
};
